<template>
  <div>
    <div class="mb-1">
      <small>Use your finger or your mouse to write your signature:</small>
    </div>
    <canvas
      id="signature-writer"
      height="300"
      width="700"
      @mousedown="handleWritingStart"
      @mousemove="handleWritingInProgress"
      @mouseup="handleDrawingEnd"
      @mouseout="handleDrawingEnd" />
    <div>
      <base-button @click="clearCanvas">Start Again</base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignatureWriter',

  data: () => ({
    canvas: null,
    ctx: null,
    fillStyle: '#333',
    lineWidth: 6,
    mousedown: false,
    shadowColor: '#333',
    strokeStyle: '#333'
  }),

  mounted () {
    this.getCanvasContext()

    // this.canvas.addEventListener('touchstart', this.handleWritingStart)
    // this.canvas.addEventListener('touchmove', this.handleWritingInProgress)
    // this.canvas.addEventListener('touchend', this.handleDrawingEnd)

    window.addEventListener('scroll', this.getCanvasContext)
  },

  destroyed () {
    window.removeEventListener('scroll', this.getCanvasContext)
  },

  methods: {
    clearCanvas () {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

      this.$emit('clear')
    },

    getCanvasContext () {
      this.canvas = document.getElementById('signature-writer')
      this.ctx = this.canvas.getContext('2d')
    },

    getMousePositionOnCanvas (event) {
      const clientX = event.clientX || event.touches[0].clientX
      const clientY = event.clientY || event.touches[0].clientY
      const { left, top } = event.target.getBoundingClientRect()
      const canvasX = clientX - left
      const canvasY = clientY - top

      return { x: canvasX, y: canvasY }
    },

    handleWritingStart (event) {
      event.preventDefault()

      const pos = this.getMousePositionOnCanvas(event)

      this.ctx.beginPath()
      this.ctx.moveTo(pos.x, pos.y)

      this.ctx.lineWidth = this.lineWidth
      this.ctx.shadowBlur = null
      this.ctx.shadowColor = null
      this.ctx.strokeStyle = this.strokeStyle

      this.ctx.fill()

      this.mousedown = true
    },

    handleWritingInProgress (event) {
      event.preventDefault()

      if (this.mousedown) {
        const pos = this.getMousePositionOnCanvas(event)

        this.ctx.lineTo(pos.x, pos.y)
        this.ctx.stroke()
      }
    },

    handleDrawingEnd (event) {
      event.preventDefault()

      if (this.mousedown) {
        this.ctx.shadowColor = this.shadowColor
        this.ctx.shadowBlur = this.lineWidth / 4

        this.ctx.stroke()
      }

      this.mousedown = false

      this.$emit('end', this.toDataUrl())
    },

    toDataUrl () {
      return this.canvas.toDataURL('image/png', 1.0)
    }
  }
}
</script>

<style lang="scss">
#signature-writer {
  border: 3px dashed #999;
}
</style>
